<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="btn-show-transaction-detail-modal"
      data-bs-toggle="modal"
      data-bs-target="#modalTransactionDetail"
    ></button>
    <div
      class="modal fade"
      id="modalTransactionDetail"
      tabindex="-1"
      aria-labelledby="modalTransactionDetailLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalTransactionDetailLabel">
              Transaction Detail
            </h5>
            <i
              style="cursor: pointer"
              class="material-icons justify-content-end"
              data-bs-dismiss="modal"
              aria-label="Close"
              >clear</i
            >
          </div>
          <div class="modal-body mb-3">
            <div class="table-responsive p-0 custom-table">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-center font-weight-bolder w-5"
                      v-for="(column, index) in columns"
                      :key="index"
                    >
                      {{ column }}
                    </th>
                  </tr>
                </thead>
                <tbody v-if="transactionDetail">
                  <tr>
                    <td
                      class="text-center text-xss w-5"
                    >
                      {{ transactionDetail.uuid }}
                    </td>
                    <td
                      class="text-center text-xss w-5"
                    >
                      {{ transactionDetail.receipt_no }}
                    </td>
                    <td
                      class="text-left text-xss w-25"
                    >
                      {{ transactionDetail.transaction_id }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.created_at_format }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.updated_at_format }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.branch_name }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                      v-if="
                        transactionDetail.member_name != '' &&
                        transactionDetail.member_name != 'Non Member'
                      "
                    >
                      {{ transactionDetail.member_id_format }}
                    </td>
                    <td
                      v-else
                      class="text-center text-xss w-10"
                    ></td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.phone_number }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.member_name }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.member_email }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.tier_name }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.total_amount_format }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.sub_total_format }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.discount_code }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.voucher_code }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.amount_direct_deduct_format }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.topup_direct_deduct_format }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.bonus_cashback_direct_deduct_format }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.cashback_earned_format }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.discount_label }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.discount_value_format }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.service_charge_amount_format }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.gst_amount_format }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.cess_amount_format }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.take_away_charge_amount_format }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.status }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.customer_remark }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.guest }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.tag }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.note }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.table_remarks }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.foc_remarks }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.operation_id }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.rounding }}
                    </td>
                    <td
                      class="text-center text-xss w-10"
                    >
                      {{ transactionDetail.payment_method }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalTransactionDetail",
  props: {
    transactionDetail: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      columns: [
        "UUID",
        "Receipt No",
        "Transaction ID",
        "Order Date Time",
        "Last Updated",
        "Branch",
        "Member ID",
        "Member Phone",
        "Member Name",
        "Member Email",
        "Tier",
        "Total Amount",
        "Sub Total",
        "Discount Code",
        "Voucher Code",
        "Deducted Amount",
        "Deducted Topup",
        "Deducted Cashback/Bonus",
        "Redemption",
        "Discount Label",
        "Discount Value",
        "Service Charge",
        "GST",
        "Cess",
        "Take Away Charge",
        "Status",
        "Customer Remark",
        "Guest",
        "Tag",
        "Note",
        "Table Remarks",
        "Foc Remarks",
        "Operation ID",
        "Rounding",
        "Payment Method",
      ],
    };
  },
};
</script>

<style scoped>
.modal {
  z-index: 99999;
}

.modal-dialog {
  max-width: 95vw;
}
</style>
